import React from 'react';

export function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--border-subtle)',
      padding: '24px 32px',
      color: 'var(--text-tertiary)',
      fontSize: '12px',
      marginTop: '32px',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px',
      }}>
        <div>
          <div style={{ marginBottom: '4px' }}>
            Cantonstats
          </div>
          <div style={{ fontFamily: 'var(--font-mono)' }}>
            Data source: scan.sv-2.global.canton.network.digitalasset.com
          </div>
        </div>

        {/* Contact Section */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}>
          <a
            href="https://x.com/michielmv"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              transition: 'color 0.15s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = 'var(--text-primary)'}
            onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}
          >
            <img src="/x-logo.png" alt="X" style={{ width: '16px', height: '16px', filter: 'invert(1)' }} />
          </a>
          <a
            href="https://t.me/michielmv"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              transition: 'color 0.15s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = 'var(--text-primary)'}
            onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}
          >
            <img src="/telegram-logo.webp" alt="Telegram" style={{ width: '18px', height: '18px', filter: 'grayscale(100%)', opacity: 0.8 }} />
          </a>
          <a
            href="mailto:michiel@melchioranalytics.com"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              transition: 'color 0.15s ease',
              fontFamily: 'var(--font-mono)',
              fontSize: '11px',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = 'var(--text-primary)'}
            onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M22 7l-10 7L2 7" />
            </svg>
            <span className="hide-mobile">michiel@melchioranalytics.com</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
